const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * Fades/slides elements with [data-urs-reveal] into place the first time
 * they cross into the viewport.
 * @param {ParentNode} root
 */
function initReveal(root) {
  const els = root.querySelectorAll('[data-urs-reveal]:not([data-urs-reveal-bound])');
  if (!els.length) return;

  if (prefersReducedMotion) {
    els.forEach((el) => {
      el.setAttribute('data-urs-reveal-bound', '');
      el.classList.add('is-visible');
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  els.forEach((el) => {
    el.setAttribute('data-urs-reveal-bound', '');
    observer.observe(el);
  });
}

/**
 * Counts [data-urs-count] elements up from 0 to their target value the first
 * time they cross into the viewport. Target text may carry a decimal part
 * ("4.8") and/or a trailing non-numeric suffix ("50+") — both are preserved.
 * @param {ParentNode} root
 */
function initCountUp(root) {
  const els = root.querySelectorAll('[data-urs-count]:not([data-urs-count-bound])');
  if (!els.length) return;

  els.forEach((el) => {
    el.setAttribute('data-urs-count-bound', '');

    const raw = el.getAttribute('data-count-target') || '';
    const match = raw.match(/^(\d+(?:\.\d+)?)(.*)$/);
    if (!match) return;

    const target = parseFloat(match[1]);
    const decimals = (match[1].split('.')[1] || '').length;
    const suffix = match[2] || '';

    if (prefersReducedMotion) return;

    const run = () => {
      const duration = 1100;
      const start = performance.now();

      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = (target * eased).toFixed(decimals) + suffix;
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = raw;
        }
      };

      requestAnimationFrame(step);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          run();
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.6 }
    );
    observer.observe(el);
  });
}

function init(root = document) {
  initReveal(root);
  initCountUp(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => init());
} else {
  init();
}

document.addEventListener('shopify:section:load', (event) => init(event.target));
